import { modal } from "@gtmhub/core/routing";

export const teamProfile = modal({
  name: ".team",
  url: ":teamId/team-details/?focusSelectManagerFiled&activeTab",
  data: {
    trackingPage: "Team Details",
  },
  params: {
    activeTab: { dynamic: true },
  },
  component: "teamProfile",
  windowClass: "profile-sidebar",
});
